import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/services')
      .then(res => res.json())
      .then(data => {
        setServices(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching services:', err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="loading">Loading services...</div>;
  }

  return (
    <div className="services-page">
      <div className="page-header">
        <h1>Our Services</h1>
        <p>Comprehensive technology solutions tailored to your business needs</p>
      </div>

      <div className="services-container">
        <div className="container">
          <div className="services-grid">
            {services.map(service => {
              const key = service.id;
              const lname = service.name.toLowerCase();
              return (
                <div key={key} className="service-card">
                  <div className="service-icon">{service.icon}</div>
                  <h3>{service.name}</h3>
                  <p>{service.description}</p>
                  {(lname.includes('payments') || lname.includes('revenue')) ? (
                    <div className="service-actions">
                      <Link to="/integrations/mpesa" className="service-btn">M-Pesa Docs</Link>
                      <Link to="/integrations/revenue" className="service-btn secondary">Revenue Docs</Link>
                    </div>
                  ) : (
                    (() => {
                      const slug = service.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
                      return (
                        <Link to={`/services/${slug}`} className="service-btn">Learn More</Link>
                      );
                    })()
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <section className="service-details">
        <div className="container">
          <h2>Detailed Service Overview</h2>
          
          <div className="detail-cards">
            <div className="detail-card">
              <h3>⚙️ Systems Installation</h3>
              <p>Specialized in installing and configuring systems for:</p>
              <ul>
                <li>Hospital Management Systems</li>
                <li>Hotel Booking & Management</li>
                <li>Car Booking Platforms</li>
                <li>School Management Systems</li>
                <li>Point of Sale (POS) Systems</li>
              </ul>
            </div>

            <div className="detail-card">
              <h3>🏢 Office Setup</h3>
              <p>Complete office infrastructure solutions including:</p>
              <ul>
                <li>IT Infrastructure Design</li>
                <li>Hardware Installation & Configuration</li>
                <li>Network Setup</li>
                <li>Workspace Organization</li>
                <li>System Integration</li>
              </ul>
            </div>

            <div className="detail-card">
              <h3>📡 WiFi Setup</h3>
              <p>Professional WiFi network services:</p>
              <ul>
                <li>High-Speed Network Installation</li>
                <li>Signal Optimization</li>
                <li>Security Configuration</li>
                <li>Load Balancing</li>
                <li>Maintenance & Support</li>
              </ul>
            </div>

            <div className="detail-card">
              <h3>📹 CCTV Setup</h3>
              <p>Complete surveillance solutions:</p>
              <ul>
                <li>Camera Installation</li>
                <li>Recording System Setup</li>
                <li>Monitoring Configuration</li>
                <li>Cloud Integration</li>
                <li>24/7 Support</li>
              </ul>
            </div>

            <div className="detail-card">
              <h3>💻 Software & E-commerce Systems</h3>
              <p>Custom software and enterprise systems tailored to your needs:</p>
              <ul>
                <li>Web Application Development</li>
                <li>Mobile App Development</li>
                <li>Desktop Software</li>
                <li>API Development</li>
                <li>Database Design</li>
                <li>E-commerce System Development & Integration</li>
              </ul>
            </div>

            <div className="detail-card">
              <h3>🔒 Cybersecurity</h3>
              <p>Protect your business from digital threats:</p>
              <ul>
                <li>Security Audits</li>
                <li>Firewall Configuration</li>
                <li>Data Encryption</li>
                <li>Threat Detection</li>
                <li>Compliance Management</li>
              </ul>
            </div>

            <div className="detail-card">
              <h3>🛠️ Hardware Maintenance</h3>
              <p>Comprehensive hardware services to keep your infrastructure running:</p>
              <ul>
                <li>Server & Network Hardware Repair</li>
                <li>POS & Peripheral Maintenance</li>
                <li>CCTV Equipment Servicing</li>
                <li>Preventive Maintenance & Inspections</li>
                <li>On-site Support & Spare Parts Procurement</li>
              </ul>
            </div>
            
            <div className="detail-card">
              <h3>💳 Payments & Revenue Integrations</h3>
              <p>Integrations for payments and tax reporting:</p>
              <ul>
                <li>M-Pesa payment collection (STK Push / C2B)</li>
                <li>Automated receipts and reconciliation</li>
                <li>Revenue Authority API integration for filings</li>
                <li>Tax invoice generation and submission</li>
                <li>Secure webhook & callback handling</li>
              </ul>
            </div>
            
            <div className="detail-card">
              <h3>💠 Firmware & Device Automation</h3>
              <p>Advanced device and firmware solutions:</p>
              <ul>
                <li>Automated firmware deployment</li>
                <li>OTA updates for IoT & mobile</li>
                <li>Device provisioning & orchestration</li>
                <li>Embedded systems testing</li>
                <li>Lifecycle management</li>
              </ul>
            </div>

            <div className="detail-card">
              <h3>💠 Blockchain & Smart Contracts</h3>
              <p>Secure decentralized application development:</p>
              <ul>
                <li>Smart contract design & auditing</li>
                <li>Enterprise blockchain solutions</li>
                <li>Tokenization & identity systems</li>
                <li>Permissioned & public chains</li>
                <li>Integration with existing systems</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
